import React from 'react';
import { ModalOverlay, Headings, Label, InputField, ErrorMessage, Button } from '@sentara-health/optimahealth_web';// replace with your actual imports
import {  
  NumberFormat
} from 'common';

interface ConfirmIdentityModalProps {
  isConfirmIdentityOpen: boolean;
  closePopUpConfirmModal: () => void;
  getValues: (field: string) => string | undefined;
  verificationCode: string;
  setVerificationCode: (code: string) => void;
  submitClicked: boolean;
  inValidOPTError: boolean;
  setInValidOPTError: (error: boolean) => void;
  setSubmitClicked: (submit: boolean) => void;
  onSubmit: () => void;
  handleOtpSubmit: () => void;
  t: (key: string) => string; // replace with your actual i18n function type
  smsInputMaxLength: number;
}

  const ConfirmIdentityModal = ({
    isConfirmIdentityOpen,
  closePopUpConfirmModal,
  getValues,
  verificationCode,
  setVerificationCode,
  submitClicked,
  inValidOPTError,
  setInValidOPTError,
  onSubmit,
  handleOtpSubmit,
  setSubmitClicked,
  t,
  smsInputMaxLength,
}: ConfirmIdentityModalProps) => {
  

  return (
       <ModalOverlay
            isOpen={isConfirmIdentityOpen}
            onClose={closePopUpConfirmModal}
            overlayInfo="Go paperless overlay"
            className="confirm_identity_modal"
          >
            <Headings
              level={2}
              text={t('profile.confirmYourIdentity')}
              variant="regular"
              dataTestId="emailNotificationsAndConsentTitle"
            />
            <div
              data-testid="phoneNotificationMessage"
              className="phone_verification_msg_wrapper"
            >
              <div className="d-flex flex-column gap-3">
                <div>
                  <span>{t('profile.phoneIdentity1')}</span>
                  <span className="ms-1">
                    {getValues('phone') ?? ''}
                  </span>
                  <span className="me-1">{t('common.dot')}</span>
                  <span className="ms-1">
                    {t('profile.phoneIdentity2')}
                  </span>
                </div>
                <div className="mb-3 position-relative">
                  <Label
                    dataTestId="verificationInputLabel"
                    htmlFor="verificationCode"
                    
                    className="pb-1"
                    >{t('profile.verificationCode')}</Label>
                  <InputField
                    className={`${
                      submitClicked && verificationCode === ''
                        ? 'error-border'
                        : ''
                    }`}
                    id="verificationCode"
                    maxLength={smsInputMaxLength}
                    data-testid="verification_code"
                    aria-describedby="verification_error"
                    value={verificationCode}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                      e.preventDefault();
                      setVerificationCode(e.target.value.replace(NumberFormat, ''));
                      setInValidOPTError(false)
                    }}
                  />

                  {/* Error message for verification code */}
                  {submitClicked && (verificationCode.length < smsInputMaxLength)  ? (
                    <div className="mt-1">
                      <ErrorMessage
                        data-testid={'verificationCodeError'}
                      >
                      {t('profile.verificationCodeError')}

                      </ErrorMessage>
                    </div>
                  ) : null }

                 

                  {submitClicked && inValidOPTError  ? (
                    <div className="mt-1">
                      <ErrorMessage
                        data-testid={'verificationCodeError'}
                      >
                      {t('profile.inValidSMSToken')}

                      </ErrorMessage>
                    </div>
                  ) : null }

                  
                  
                  <Button
                    variant="btn-links text-decoration-underline bg-transparent border-0 p-0 mt-1"
                    dataTestId="resendVerificationTitle"
                    onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
                      e.preventDefault();
                      onSubmit();
                    }}
                   >
                    {t('profile.resendVerification')}
                   </Button>
                </div>
                <div className="d-flex flex-lg-row flex-md-row flex-column gap-lg-3 gap-md-3 gap-4 mb-2">
                  <Button
                    dataTestId={'submit_code'}
                    variant="primary_btn"
                    disabled={verificationCode.length < smsInputMaxLength}
                    onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
                      e.preventDefault();
                      setSubmitClicked(true);
                      if(verificationCode.length === smsInputMaxLength){
                        handleOtpSubmit();
                      }
                      
                    }}
                  >
                    {t('profile.submitCode')}
                  </Button>
                  <Button
                    dataTestId={'verification_cancel_button'}
                    variant='secondary_btn'
                    onClick={closePopUpConfirmModal}
                  >
                  {t('common.cancel')}
                  </Button>
                </div>
              </div>
            </div>
          </ModalOverlay>
    )
};

export default ConfirmIdentityModal;